import React, { useEffect, useRef, useState } from "react";
import "react-image-lightbox/style.css";
import Lightbox from "react-image-lightbox";

import "./addcustomer.scss";
import { Autocomplete, Chip, TextField } from "@mui/material";
import useAddCustomerUtils from "./addcustomerUtils.js";
import { TitleHeader } from "../../../../components/index.js";
import { images } from "../../../../utils/customFn.js";
import OverlayLoading from "../../../../common/OverlayLoader/Overlayloader.js";
import { useSelector } from "react-redux";

const AddCustomer = () => {
  const { city_list: cityOptions } = useSelector((state) => state.userAuth);
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const breadcrumbs = [
    { label: "Pages", link: "" },
    { label: "Add Page", link: "" },
  ];

  const {
    formData,
    loading,
    handleFormChange,
    submitForm,
    formErrors,
    setFormData,
    navigate,
  } = useAddCustomerUtils();

  // Function to check if a file is an image
  const isImage = (file) => {
    return file && /\.(jpg|jpeg|png|gif)$/i.test(file);
  };

  // Function to check if a file is a PDF
  const isPDF = (file) => {
    return file && /\.pdf$/i.test(file);
  };

  const [selectedImage, setSelectedImage] = useState(null);

  const inputRef = useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setFormData((prev) => ({
        ...prev,
        profile_picture: file,
      }));
      setSelectedImage(imageUrl);
    }
  };

  const TypesList = [
    { _id: "Pending", title: "Pending" },
    { _id: "Verified", title: "Verified" },
    { _id: "Rejected", title: "Rejected" },
    { _id: "Verification Requested", title: "Verification Requested" },
  ];

  const openLightbox = (imageUrl) => {
    setPhotoIndex(imageUrl);
    setIsOpen(true);
  };

  console.log("cityOptions:", cityOptions);
  console.log("formData?.city:", formData);

  return (
    <>
      <TitleHeader heading="Edit Customer " breadcrumbs={breadcrumbs} />

      <OverlayLoading isLoading={loading}>
        <div className="employee-profile">
          <div className="page-card-bg table-data-new">
            <div className="header">
              <div className="profile-image-container">
                <img
                  src={
                    selectedImage ||
                    formData?.profile_picture ||
                    images["dummy.png"]
                  }
                  alt="Profile"
                  className="profile-image"
                />

                <span onClick={() => inputRef.current.click()}>
                  <svg
                    width="12"
                    height="13"
                    viewBox="0 0 12 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.864962 9.91591L0.0302158 12.1419C-0.00183801 12.2276 -0.00855697 12.3206 0.0108616 12.41C0.0302802 12.4994 0.0750154 12.5813 0.139725 12.646C0.204434 12.7106 0.286382 12.7552 0.375782 12.7746C0.465183 12.7939 0.558256 12.7871 0.643888 12.7549L2.86924 11.9202C3.12395 11.8248 3.35529 11.676 3.54771 11.4838L9.99381 5.03767C9.99381 5.03767 9.76892 4.36364 9.09554 3.68962C8.42215 3.01623 7.74749 2.79135 7.74749 2.79135L1.30139 9.23744C1.10917 9.42987 0.960359 9.66121 0.864962 9.91591ZM8.6464 1.89244L9.52498 1.01386C9.68253 0.85631 9.8928 0.755937 10.1126 0.792783C10.422 0.843604 10.8953 0.99734 11.3412 1.44394C11.7878 1.89053 11.9416 2.36317 11.9924 2.67255C12.0292 2.89235 11.9288 3.10263 11.7713 3.26018L10.8921 4.13876C10.8921 4.13876 10.6678 3.46537 9.99381 2.79198C9.32042 2.11732 8.6464 1.89244 8.6464 1.89244Z"
                      fill="#01265D"
                    ></path>
                  </svg>
                  <input
                    id="image-upload"
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handleImageChange}
                    ref={inputRef}
                  />
                </span>
              </div>
            </div>

            <div className="form-data-main">
              <form onSubmit={submitForm}>
                <div className="page-card-bg data-page-big-height">
                  <div className="form-all-grid">
                    <div className="input-main-data">
                      <label>name</label>
                      <input
                        type="text"
                        name="name"
                        onChange={handleFormChange}
                        value={formData?.name}
                      />
                      {formErrors?.name && (
                        <div className="error_message">{formErrors?.name}</div>
                      )}
                    </div>

                    <div className="input-main-data">
                      <label>phone number</label>
                      <input
                        type="text"
                        name="phone_number"
                        disabled
                        onChange={handleFormChange}
                        value={formData?.phone_number}
                      />
                      {formErrors?.phone_number && (
                        <div className="error_message">
                          {formErrors?.phone_number}
                        </div>
                      )}
                    </div>

                    <div className="input-main-data">
                      <label>email</label>
                      <input
                        type="email"
                        name="email"
                        onChange={handleFormChange}
                        value={formData?.email}
                      />
                      {formErrors?.email && (
                        <div className="error_message">{formErrors?.email}</div>
                      )}
                    </div>
                  </div>

                  {formData?.verification_step == "4" && (
                    <>
                      <div className="form-all-grid">
                        <div className="input-main-data">
                          <label>gender</label>
                          <input
                            type="text"
                            name="gender"
                            onChange={handleFormChange}
                            value={formData?.gender}
                          />
                          {formErrors?.gender && (
                            <div className="error_message">
                              {formErrors?.gender}
                            </div>
                          )}
                        </div>

                        <div className="input-main-data">
                          <label>Transportation mode</label>
                          <input
                            type="text"
                            name="transportation_mode"
                            onChange={handleFormChange}
                            value={formData?.transportation_mode}
                            disabled
                          />
                          {formErrors?.transportation_mode && (
                            <div className="error_message">
                              {formErrors?.transportation_mode}
                            </div>
                          )}
                        </div>

                        <div className="input-main-data">
                          <label htmlFor="">Driver Verification Status</label>
                          <Autocomplete
                            fullWidth
                            className="automcomplete_select_info"
                            autoComplete={false}
                            id="free-solo-demo"
                            options={TypesList}
                            getOptionLabel={(option) => option?.title}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select Status"
                              />
                            )}
                            value={
                              TypesList.find(
                                (type) =>
                                  type._id == formData?.verification_status
                              ) || null
                            }
                            onChange={(e, value) => {
                              setFormData((prev) => ({
                                ...prev,
                                verification_status: value?._id,
                              }));
                            }}
                          />
                        </div>
                      </div>

                      <div className="form-all-grid">
                        <div className="input-main-data">
                          <label>Id Number</label>
                          <input
                            type="text"
                            name="transportation_mode"
                            onChange={handleFormChange}
                            value={formData?.id_number}
                            disabled
                          />
                          {formErrors?.id_number && (
                            <div className="error_message">
                              {formErrors?.id_number}
                            </div>
                          )}
                        </div>

                        <div className="input-main-data">
                          <label>Car Name</label>
                          <input
                            type="text"
                            name="transportation_mode"
                            onChange={handleFormChange}
                            value={formData?.car_name}
                            disabled
                          />
                          {formErrors?.car_name && (
                            <div className="error_message">
                              {formErrors?.car_name}
                            </div>
                          )}
                        </div>

                        <div className="input-main-data">
                          <label htmlFor="">Driver Status</label>
                          <Autocomplete
                            fullWidth
                            className="automcomplete_select_info"
                            autoComplete={false}
                            id="driver_status"
                            options={[
                              { id: 1, title: "On" },
                              { id: 0, title: "Off" },
                            ]}
                            getOptionLabel={(option) => option?.title}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select Status"
                              />
                            )}
                            value={
                              [
                                { id: 1, title: "On" },
                                { id: 0, title: "Off" },
                              ].find(
                                (type) => type.id == formData?.driver_status
                              ) || null
                            }
                            onChange={(e, value) => {
                              setFormData((prev) => ({
                                ...prev,
                                driver_status: value ? value.id : "",
                              }));
                            }}
                          />
                        </div>
                      </div>
                    </>
                  )}

                  <div className="form-all-grid">
                    <div className="input-main-data">
                      <label htmlFor="">City</label>
                      <Autocomplete
                        fullWidth
                        className="automcomplete_select_info"
                        autoComplete={false}
                        id="gfdahhhshshshss"
                        options={
                          cityOptions?.map((city) => ({
                            id: city?.id,
                            title: city?.name,
                          })) || []
                        }
                        getOptionLabel={(option) => option?.title || ""}
                        isOptionEqualToValue={(option, value) =>
                          option?.id == value?.id
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select City"
                            autoComplete="off"
                          />
                        )}
                        value={
                          cityOptions
                            ?.map((city) => ({
                              id: city?.id,
                              title: city?.name,
                            }))
                            .find((city) => city?.id == formData?.city) || null
                        }
                        onChange={(e, value) => {
                          setFormData((prev) => ({
                            ...prev,
                            city: value ? Number(value.id) : "",
                          }));
                        }}
                      />
                    </div>

                    <div className="input-main-data">
                      <label htmlFor="">Status</label>
                      <Autocomplete
                        fullWidth
                        className="automcomplete_select_info"
                        autoComplete={false}
                        id="status"
                        options={[
                          { id: "Active", title: "Active" },
                          { id: "Deactive", title: "Deactive" },
                        ]}
                        getOptionLabel={(option) => option?.title}
                        renderInput={(params) => (
                          <TextField {...params} placeholder="Select Status" />
                        )}
                        value={
                          [
                            { id: "Active", title: "Active" },
                            { id: "Deactive", title: "Deactive" },
                          ].find((type) => type.id == formData?.status) || null
                        }
                        onChange={(e, value) => {
                          setFormData((prev) => ({
                            ...prev,
                            status: value ? value.id : "",
                          }));
                        }}
                      />
                    </div>

                    <div className="input-main-data"></div>
                  </div>

                  {formData?.verification_step == "4" && (
                    <>
                      {/* Driver Document Details Section */}
                      {(formData?.profile_picture ||
                        formData?.driving_license ||
                        formData?.vehicle_registration ||
                        formData?.live_photo ||
                        formData?.car_photo) && (
                        <div className="driver-documents">
                          <h3>Driver Document Details</h3>

                          <div className="form-all-grid">
                            {[
                              "driving_license",
                              "vehicle_registration",
                              "live_photo",
                              "car_photo",
                            ].map(
                              (key) =>
                                formData[key] && (
                                  <div key={key} className="input-main-data">
                                    <label>
                                      {key.replace("_", " ").toUpperCase()}
                                    </label>
                                    {isImage(formData[key]) ? (
                                      <img
                                        src={formData[key]}
                                        alt={`${key} Preview`}
                                        className="preview-image"
                                        onClick={() =>
                                          openLightbox(formData[key])
                                        }
                                        style={{ cursor: "pointer" }}
                                      />
                                    ) : isPDF(formData[key]) ? (
                                      <div className="pdf-preview">
                                        <a
                                          href={formData[key]}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          📄 View PDF
                                        </a>
                                        <a href={formData[key]} download>
                                          ⬇️ Download PDF
                                        </a>
                                      </div>
                                    ) : (
                                      <p>Unsupported file format</p>
                                    )}
                                  </div>
                                )
                            )}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div className="btn-form-send">
                  <button
                    type="button"
                    class="common-button cancel-btn"
                    onClick={() =>
                      navigate(`/customers/${formData.customer_type}`)
                    }
                  >
                    Cancel
                  </button>
                  <button className="common-button" disabled={loading}>
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </OverlayLoading>

      {isOpen && (
        <div className="custom-lightbox-overlay">
          <div className="custom-lightbox-content">
            <img
              src={photoIndex}
              alt="Document preview"
              className="custom-lightbox-image"
            />
            <button
              className="custom-lightbox-close"
              onClick={() => setIsOpen(false)}
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default AddCustomer;
